import React from 'react';
import MaskedInput from 'react-text-mask';
// tslint:disable-next-line: no-submodule-imports
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const defaultMaskOptions = {
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.',
    allowDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 2, 
    integerLimit: 10, 
    allowNegative: false,
    allowLeadingZeroes: false,
};

interface IMaskOptions {
    prefix: string;
    suffix: string;
    includeThousandsSeparator: boolean;
    thousandsSeparatorSymbol: string;
    allowDecimal: boolean;
    decimalSymbol: string;
    decimalLimit: string;
    requireDecimal: boolean;
    allowNegative: boolean;
    allowLeadingZeroes: boolean;
    integerLimit: number;
}

interface ICurrencyInputProps {
    inputRef: (ref: HTMLInputElement | null) => void;
    maskOptions: IMaskOptions;
    allowNegative: boolean;
}

const CurrencyInput = (props: ICurrencyInputProps) => {
    const { inputRef, allowNegative, ...other } = props;

    const currencyMask = createNumberMask({
        ...defaultMaskOptions,
        ...props.maskOptions,
        allowNegative,
    });

    return (
        <MaskedInput
            onFocus={e => {
                // change cursor to end of input
                const val = e.target.value;
                e.target.value = '';
                e.target.value = val;
            }}
            mask={currencyMask}
            {...other}
            ref={(ref: any) => {
                inputRef(ref ? ref.inputElement : null);
            }}
        />
    );
};

export default CurrencyInput;